// removed by extract-text-webpack-plugin
module.exports = {"pdfjs":"_1f724023","outerContainer":"_8af6079c","secondaryToolbar":"da5cf80a","doorHangerRight":"_2913db81","toolbarContainer":"_2b03fddb","toolbarViewerMiddle":"a06bebb9","progressBar":"e1c1f0c5","back-to-application":"_33e1fd8d","subscriber":"_8887596f","loader":"_31d9ec0e","noVideo":"a2dda023","fullView":"_05242f18","collapsed":"_06dac689","me":"adb7a960","isDragging":"_0fa2448f","fullScreenView":"_5b0b1a13"};


//////////////////
// WEBPACK FOOTER
// ./src/components/VirtualVideoRoom/Components/ActiveSpeaker/styles.styl
// module id = 5153
// module chunks = 39